import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Text } from 'shared/components'
import CustomIcon from 'shared/components/customIcon'

import * as styles from './styles'

const MobileDeleteAccountSectionComponent = ({
	onDeleteClick,
}) => {
	const [showConfirmation, setShowConfirmation] = useState(false)

	const handleDeleteClick = () => {
		setShowConfirmation(true)
	}

	const handleConfirmDelete = () => {
		setShowConfirmation(false)
		if (onDeleteClick) {
			onDeleteClick()
		}
	}

	const handleCancelDelete = () => {
		setShowConfirmation(false)
	}

	return (
		<>
			<div css={styles.deleteContainer}>
				<div css={[styles.deleteCard]} onClick={handleDeleteClick}>
					<div css={styles.deleteContent}>
						<Text size={11} css={styles.deleteLabel}>
							Delete Account
						</Text>
						<CustomIcon
							icon="angleRight"
							css={styles.arrowIcon}
							size={20}
						/>
					</div>
				</div>
			</div>

			{/* Delete Account Confirmation Popup */}
			{showConfirmation && (
				<div css={styles.overlay}>
					<div css={styles.popup}>
						<div css={styles.popupContent}>
							<Text size={14} bold css={styles.title}>
								Delete Account<br />
							</Text>
							<Text size={12} css={styles.message}>
								Are you sure you want to delete<br />your account?
							</Text>
							<div css={styles.spacer}></div>
							<div css={styles.buttonContainer}>
								<button
									css={[styles.button, styles.noButton]}
									onClick={handleCancelDelete}
								>
									<Text size={12} medium css={styles.noButtonText}>
										No
									</Text>
								</button>
								<button
									css={[styles.button, styles.yesButton]}
									onClick={handleConfirmDelete}
								>
									<Text size={12} medium css={styles.yesButtonText}>
										Yes
									</Text>
								</button>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	)
}

MobileDeleteAccountSectionComponent.propTypes = {
	onDeleteClick: PropTypes.func,
}

export default MobileDeleteAccountSectionComponent 